import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { desktopSize } from 'theme'

import { useTrackingStore } from 'store/trackingStore'
import { COUPON_SCREEN_NAME, EVENT_ACTION, BUTTON_NAME } from 'tracking'

import IndexOffSvg from '/static/images/tabs/bottom-tab-ic-index-off.svg'
import IndexOnSvg from '/static/images/tabs/bottom-tab-ic-index-on.svg'
import MyCouponOffSvg from '/static/images/tabs/bottom-tab-ic-mycoupon-off.svg'
import MyCouponOnSvg from '/static/images/tabs/bottom-tab-ic-mycoupon-on.svg'
import MoreOffSvg from '/static/images/tabs/bottom-tab-ic-more-off.svg'
import MoreOnSvg from '/static/images/tabs/bottom-tab-ic-more-on.svg'

const BottomTabs = () => {
  const router = useRouter()
  const { trackEvent, isInited } = useTrackingStore()

  const { pathname } = router
  const tabs = [
    {
      title: '主頁',
      icon: <IndexOffSvg />,
      selectedIcon: <IndexOnSvg />,
      path: '/skus',
      screen: COUPON_SCREEN_NAME.SKUS,
    },
    {
      title: '我的優惠券',
      icon: <MyCouponOffSvg />,
      selectedIcon: <MyCouponOnSvg />,
      path: '/mycoupon',
      screen: COUPON_SCREEN_NAME.MYCOUPON,
    },
    {
      title: '更多',
      icon: <MoreOffSvg />,
      selectedIcon: <MoreOnSvg />,
      path: '/settings',
      screen: COUPON_SCREEN_NAME.SETTINGS,
    },
  ]
  const handleTabClick = (tab) => {
    if (isInited) {
      trackEvent(EVENT_ACTION.CLICK, {
        screen: tab.screen,
        button: BUTTON_NAME.TAB,
        tab: tab.title,
      })
    }
    router.push(tab.path)
  }
  const TabIcon = ({ tab }) => {
    return <>{pathname === tab.path ? tab.selectedIcon : tab.icon}</>
  }

  return (
    <BottomTabsWrapper>
      {tabs.map((tab, index) => (
        <TabBox key={index} onClick={() => handleTabClick(tab)}>
          <TabIcon tab={tab} />
          <TabTitle selected={pathname === tab.path}>{tab.title}</TabTitle>
        </TabBox>
      ))}
    </BottomTabsWrapper>
  )
}
const BottomTabsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  bottom: 0;
  left: 0;
  height: 56px;
  width: 100%;
  z-index: 2;
  background-color: ${(p) => p.theme.color.white};
  box-shadow: 0 -5px 12px -5px ${(p) => p.theme.color.grey80};
  @media ${desktopSize} {
    display: none;
  }
`
const TabBox = styled.div`
  width: 30%;
  text-align: center;
`
const TabTitle = styled.div`
  font-size: 12px;
  color: ${(p) => (p.selected ? p.theme.color.blue200 : p.theme.color.grey400)};
`

export default BottomTabs
